import { InjectionToken } from '@angular/core';

/**
 * Provider that allows a consumer to explicitly provide the IFileUploadConfig.
 */
export const FILE_UPLOAD_CONFIG = new InjectionToken('FILE_UPLOAD_CONFIG');

/**
 * Interface that represents the required and optional configuration values for the module.
 */
export interface IFileUploadConfig {
  maxFileBytes: number;
  allowedFileTypes: string[];
}
